// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';

function handleInternalDeereCommentsChange(event) {

    this.onInternalDeereCommentsChange(event.target.value);

}

function handleCommentsToDealerChange(event) {

    this.onCommentsToDealerChange(event.target.value);

}

function handleConfirmation() {

    this.onConfirmation(this.amountOfUseModalAction, this.amountOfUseRequestItemToUpdate);

}

const AmountOfUseModalBody = props =>
    <section className='machine-update-modal-body'>
        <div className='row'>
            <LabeledString
                className='pin'
                data={props.amountOfUseRequestItemToUpdate.pin}
                label='PIN'
            />
        </div>
        <div className='row'>
            <span className='data-label internal-deere-comments'>
                <FormattedMessage id='INTERNAL_DEERE_COMMENTS'/>
            </span>
            <textarea
                maxLength='120'
                onChange={props::handleInternalDeereCommentsChange}
            >
            </textarea>
        </div>
        <div className='row'>
            <span className='data-label comments-to-dealer'>
                <FormattedMessage id='COMMENTS_TO_DEALER'/>
            </span>
            <textarea
                maxLength='120'
                onChange={props::handleCommentsToDealerChange}
            >
            </textarea>
        </div>
        <div className='button'>
            <button
                className='primary'
                onClick={props::handleConfirmation}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </section>;

AmountOfUseModalBody.displayName = 'AmountOfUseModalBody';
AmountOfUseModalBody.propTypes = {
    amountOfUseModalAction: PropTypes.string.isRequired,
    amountOfUseRequestItemToUpdate: PropTypes.instanceOf(MeasurementReading).isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default AmountOfUseModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/amount-of-use-update-modal-body.js